var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as React from 'react';
import { getShape, getColor, getBackgroundColor, getBorderColor } from '../util';
const SvgColetaDePacote = _a => {
  var {
      size,
      shape = 'circle',
      neutral = false
    } = _a,
    props = __rest(_a, ["size", "shape", "neutral"]);
  const backgroundColor = getBackgroundColor(shape, neutral);
  const color = getColor(shape, neutral);
  const borderColor = getBorderColor(neutral);
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: size !== null && size !== void 0 ? size : 96,
    height: size !== null && size !== void 0 ? size : 96,
    fill: "none",
    viewBox: "0 0 96 96"
  }, props), getShape(shape, backgroundColor), React.createElement("path", {
    fill: "var(--color-neutral-70)",
    d: "M18.866 77.112h8.65L61.633 66V53.25c0-2.083-.883-10.5-11.074-10.926H25.203c-8.12 0-14.703 6.582-14.703 14.702v11.72a8.366 8.366 0 0 0 8.366 8.366Z"
  }), React.createElement("path", {
    fill: "var(--color-neutral-80)",
    d: "M21 65.25V58.5h.75l3 5.25 3.75 3h-6l-1.5-1.5Z"
  }), React.createElement("path", {
    fill: "var(--color-neutral-80)",
    d: "M18 74.25h8.25l.751 3h-7.5l-3.75-.75-3.75-3-1.5-3.75V60l1.5-9.75 4.5-5.25 2.25-.75c-2.25 1.5-5.825 4.92-6 9.75-.082 2.248 0 11.25 0 14.25s1.5 6 5.25 6Z"
  }), React.createElement("path", {
    fill: "var(--color-neutral-70)",
    stroke: borderColor,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M39.402 36.349c-7.969 0-14.425-6.455-14.425-14.424 0-7.968 6.456-14.425 14.425-14.425 7.968 0 14.423 6.46 14.423 14.424 0 7.963-6.458 14.423-14.423 14.423v.002Z"
  }), React.createElement("path", {
    stroke: borderColor,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M27.516 77.112h-8.65a8.366 8.366 0 0 1-8.366-8.366v-11.72c0-8.12 6.583-14.702 14.703-14.702H47.25c14.25 0 14.383 10.176 14.383 10.176"
  }), React.createElement("path", {
    stroke: borderColor,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M27.711 66.397h-5.042a1.68 1.68 0 0 1-1.68-1.68v-6.16"
  }), React.createElement("path", {
    fill: "var(--color-neutral-70)",
    stroke: borderColor,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M39.4 36.349c-7.968 0-14.424-6.455-14.424-14.424C24.976 13.957 31.432 7.5 39.4 7.5c7.968 0 14.423 6.46 14.423 14.424 0 7.963-6.458 14.423-14.423 14.423v.002Z"
  }), React.createElement("path", {
    fill: "var(--color-neutral-80)",
    d: "m53.25 21-28.5 1.5.75-3.75h27.75V21Z"
  }), React.createElement("path", {
    stroke: borderColor,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M39.4 36.349c-7.968 0-14.424-6.455-14.424-14.424C24.976 13.957 31.432 7.5 39.4 7.5c7.968 0 14.423 6.46 14.423 14.424 0 7.963-6.458 14.423-14.423 14.423v.002Z"
  }), React.createElement("path", {
    fill: color,
    stroke: borderColor,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M39.4 7.5c-7.047 0-12.913 5.051-14.174 11.732h28.347C52.313 12.554 46.45 7.5 39.401 7.5Z"
  }), React.createElement("path", {
    fill: color,
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M39.4 7.5c-7.047 0-12.913 5.051-14.174 11.732H58.73c2.771 0 2.771-3.482-.229-3.482h-6c-3-5.25-6.768-8.25-13.1-8.25Z"
  }), React.createElement("path", {
    fill: "var(--color-neutral-70)",
    stroke: borderColor,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M67.45 52.5H31.5v35.95h35.95V52.5Z"
  }), React.createElement("path", {
    fill: color,
    stroke: borderColor,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m54.93 64.816-5.454-2.652-5.454 2.652V52.5H54.93v12.316Z"
  }), React.createElement("path", {
    stroke: borderColor,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M57 82.5V84M60 82.5V84M63 82.5V84"
  }), React.createElement("path", {
    fill: "var(--color-neutral-70)",
    stroke: borderColor,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M37.5 71.25c.16-2.306-2.052-2.646-3.75-3.75-.664-.43 1.5-1.5 0-3s-6.663 1.357-6.75 3l-.338 7.624c-.088 1.63.573 2.283 3.005 2.533 3.332.343 7.597-.775 7.832-4.157v-2.25Z"
  }), React.createElement("path", {
    fill: "var(--color-neutral-80)",
    d: "M37.5 72c-.98 1.624-1.499 2.25-2.999 3s-5.41.626-6.75 0c-1.5-1.5-1.001-2.838-1.089-1.195v1.32c-.087 1.63.574 2.282 3.005 2.532C33 78 37.265 76.882 37.5 73.5V72Z"
  }), React.createElement("path", {
    stroke: borderColor,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M37.5 71.25c.16-2.306-2.052-2.646-3.75-3.75-.664-.43 1.5-1.5 0-3s-6.663 1.357-6.75 3l-.338 7.624c-.088 1.63.573 2.283 3.005 2.533 3.332.343 7.597-.775 7.832-4.157v-2.25Z"
  }), React.createElement("path", {
    fill: "var(--color-neutral-70)",
    stroke: borderColor,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M64.22 71.102c.103 3.216 2.676 4.96 5.5 5.607 1.605.368 3.131-.864 3.055-2.51l-.33-7.06c-.077-1.633-1.69-2.716-3.252-2.22-2.722.866-5.08 2.79-4.972 6.183Z"
  }), React.createElement("path", {
    fill: "var(--color-neutral-80)",
    d: "M64.501 72.75c0 1.5 3.84 4.47 6 3.75 2.25-.75 2.35-.655 2.274-2.3V72c-.077-1.633-.713 1.754-2.274 2.25-2.722.866-6-2.306-6-1.5Z"
  }), React.createElement("path", {
    stroke: borderColor,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M64.22 71.102c.103 3.216 2.676 4.96 5.5 5.607 1.605.368 3.131-.864 3.055-2.51l-.33-7.06c-.077-1.633-1.69-2.716-3.252-2.22-2.722.866-5.08 2.79-4.972 6.183Z"
  }), React.createElement("path", {
    fill: "var(--color-neutral-70)",
    stroke: borderColor,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M77.185 49.644s-9.54-8.51-9.54-18.665c0-5.268 4.27-9.54 9.54-9.54a9.54 9.54 0 0 1 9.54 9.54c0 10.155-9.54 18.665-9.54 18.665Z"
  }), React.createElement("path", {
    fill: "var(--color-neutral-80)",
    d: "M78 49.5s-10.355-8.366-10.355-18.521c0-5.268 2.835-9.229 8.105-9.229 6 0-4.5 0-5.25 8.25 0 10.155 7.5 19.5 7.5 19.5Z"
  }), React.createElement("path", {
    fill: backgroundColor,
    stroke: borderColor,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M77.185 34.605a3.627 3.627 0 1 0 0-7.253 3.627 3.627 0 0 0 0 7.253Z"
  }), React.createElement("path", {
    stroke: borderColor,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M77.185 49.644s-9.54-8.51-9.54-18.665c0-5.268 4.27-9.54 9.54-9.54a9.54 9.54 0 0 1 9.54 9.54c0 10.155-9.54 18.665-9.54 18.665Z"
  }));
};
export default SvgColetaDePacote;